import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { useHelpStore } from '../help/HelpStore';
import { useAmplitudeHelpStore } from "../third-party-integration/amplitude/useAmplitudeHelpStore";
export interface IWebView {
    id: string;
    name: string;
    url: string;
    deepLink?: string;
    visitedPath?: string;
    visitedOrigin?: string;
    icon: string;
    iconText: string;
    active: boolean;
    type: string;
    appId?:string;
    logoutUrl?:string;
    index?: number;
  }
  
  interface IWebViewStore {
    webviews: IWebView[];
    visualOrder: string[];
    customView : any ;
    addWebView: (entry: Omit<IWebView, "active">) => void;
    setActiveWebView: (id: string) => void;
    removeWebView: (id: string) => any;
    resetActive: () => void;
    getActiveIframe: () => IWebView | undefined;
    removeAllWebView:() => void;
    setCustomWebView:(view: any) => void;
    setVisitedLocation: (id: string, visitedPath: string, visitedOrigin?: string) => void;
    setIndex:  (id:string,index:number) => void;
  }
  
  export const useStore = create((set) => ({
    isLoading: false,
    setIsLoading: (val:boolean) => set({ isLoading: val }),
    setName:(val:boolean) => set({ name: val }),
    name:'',
  }));
  
  export const useWebViewStore = create<IWebViewStore>()(
    
    persist(
      (set, get) => ({
        webviews: [],
        visualOrder: [],
        customView :null ,
        addWebView: ({ id, name, url, icon, iconText , type , appId, logoutUrl, deepLink }) => {
          const existing = get().webviews.find((i) => i.id === id);
          console.log('existing', existing);
          if (existing) {
            set((state) => ({
              webviews: get().webviews.map((i) => ({
                ...i,
                deepLink,
                active: i.id === id,
              })),
              visualOrder: [id, ...state.visualOrder.filter((vId) => vId !== id)],
              customView: null,
            }));

            if (existing.active) return;
          } else {
            set((state) => ({
              webviews: [
                { id, name, url, icon, iconText, type, appId, logoutUrl, deepLink, active: true },
                ...get().webviews.map((i) => ({ ...i, active: false })),
              ],
              visualOrder: [id, ...state.visualOrder],
              customView: null,
            }));
          }
          useHelpStore.getState().setCurrentAppInView(id);
          useAmplitudeHelpStore.getState().setCurrentAppInView(id);
        },

        setCustomWebView: (customView:any) => set((state) => ({
            webviews: state.webviews.map((i) => ({
              ...i,
              active: false,
            })),
            customView:customView
          })),

        setActiveWebView: (id: string) => {
          set((state) => {
            if (!state.webviews.some((w) => w.id === id)) return state;

            // 1. Update active state WITHOUT changing the webviews array index
            const updatedWebviews = state.webviews.map((w) => ({
              ...w,
              active: w.id === id,
            }));

            // 2. Move the active ID to the top of the visual order array
            const newVisualOrder = [id, ...state.visualOrder.filter((vId) => vId !== id)];

            return {
              webviews: updatedWebviews,
              visualOrder: newVisualOrder,
              customView: null,
            };
          });

          useHelpStore.getState().setCurrentAppInView(id);
          useAmplitudeHelpStore.getState().setCurrentAppInView(id);
        },

        resetActive:() => {
            set((state) => ({
            webviews: state.webviews.map((i) => ({
              ...i,
              active: false,
            })),
            customView:null
          }))
          useHelpStore.getState().setCurrentAppInView('unify');
          useAmplitudeHelpStore.getState().setCurrentAppInView('unify');
        },

        setIndex:(id:string,index:number) => {
            set((state) => {
            if (!state.webviews.some((w) => w.id === id)) return state;

            const updatedWebviews = state.webviews.map((w) => ({
              ...w,
              index: w.id === id ? index : w.index,
            }));

            return {
              webviews: updatedWebviews,
              visualOrder: state.visualOrder,
              customView: state.customView,
            };
          });
        },
  
        removeWebView:(id) => {
            set((state) => ({
              webviews: state.webviews.filter((iframe) => iframe.id !== id),
              visualOrder: state.visualOrder.filter((vId) => vId !== id),
            }))
            useHelpStore.getState().setCurrentAppInView('unify');
            useAmplitudeHelpStore.getState().setCurrentAppInView('unify');
            return get().webviews;
        },

        removeAllWebView:() => {
            set((state) => ({
              webviews: [],
              visualOrder: [],
            }))
            useHelpStore.getState().setCurrentAppInView('unify');
            useAmplitudeHelpStore.getState().setCurrentAppInView('unify');
        },

        getActiveIframe: () => get().webviews.find((i) => i.active),

        setVisitedLocation: (id, visitedPath, visitedOrigin) => {
          if (!id || !visitedPath) {
            return;
          }
          set((state) => ({
            webviews: state.webviews.map((i) =>
              i.id === id ? { ...i, visitedPath, visitedOrigin: visitedOrigin || i.visitedOrigin } : i
            ),
          }));
        },
      }),
      {
        name: "unify-pane-store",
        storage: createJSONStorage(() => localStorage),
        onRehydrateStorage: () => (state, error) => {
          if (state?.webviews) {
            const active = state.webviews.find(v => v.active);
            if (active?.id) {
              setTimeout(() => {
                useHelpStore.getState().setCurrentAppInView(active.id);
                useAmplitudeHelpStore.getState().setCurrentAppInView(active.id);
              }, 0);
            }
        }
      }
      }
    )
  );
